export interface Bonus {
  title: string
  description: string
}

export const bonuses: Bonus[] = [
  {
    title: '🎁 BONUS 1 — Rider Assessment & Correction Toolkit™',
    description:
      'Professional observation sheets, correction matrices, decision maps, cue testing tools, progression checks, and rider review resources.',
  },
  {
    title: '🎁 BONUS 2 — Arena Setup & Exercise Design Toolkit™',
    description:
      'Professional arena planning tools, visual layouts, setup variations, progressions, regressions, limited-space adaptations, and reusable arena structures.',
  },
  {
    title: '🎁 BONUS 3 — Rider–Horse Adaptation System™',
    description:
      'Ready-to-use tools for adapting exercises, lesson difficulty, rider level, horse-rider combinations, confidence, consistency, and progression.',
  },
  {
    title: '🎁 BONUS 4 — Private & Group Lesson Management Toolkit™',
    description:
      'Professional planning tools for private lessons, semi-private sessions, group classes, mixed-level riders, arena flow, observation, and group progression.',
  },
  {
    title: '🎁 BONUS 5 — Professional Rider Progress & Documentation Kit™',
    description:
      'Rider profiles, lesson records, progress tracking, goals, development blocks, session continuity tools, next-lesson planning, and professional documentation.',
  },
]
